/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "FirstPartyAddon": {
                "values": {
                  "DO_NOT_USE_ADDON": 0,
                  "CASH_MANAGEMENT": 1,
                  "OPEN_TICKETS": 2,
                  "GIFT_CARD": 3,
                  "TEAM_MANAGEMENT": 4,
                  "INVOICES": 5,
                  "ONLINE_CHECKOUT": 6,
                  "LOYALTY": 7,
                  "MARKETING_EMAIL": 8,
                  "ORDER_MANAGER": 9,
                  "TEXT_MESSAGE_MARKETING": 10,
                  "ROUND_UP_FOR_CHARITY": 11,
                  "ONLINE": 12,
                  "BUYER_SUBSCRIPTIONS": 13,
                  "MESSAGES": 14,
                  "SHIFTS": 15,
                  "ESTIMATES": 16,
                  "BILL_PAY": 17,
                  "CONTRACTS": 18,
                  "RETAIL": 19,
                  "STAFF": 20
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.FirstPartyAddon) {
  $root.addJSON(jsonData);
}

/**
 * All supported first party addons.
 *
 * SOURCE FirstPartyAddon @ squareup/addons/data/first_party_addons.proto at 9:1
 */
export const FirstPartyAddon = $root.lookupEnum('squareup.addons.data.FirstPartyAddon').values;